<script setup lang="ts">
import { computed, inject, ref } from "vue";
import { locale } from "../locale";
import SwitchItem from "./SwitchItem.vue";

const props = defineProps<{
  currentMicroLevel: number;
  noiseSuppression: boolean;
}>();

const emit = defineEmits<{
  (e: "updateNoiseSuppression", value: boolean): void;
}>();

// Тема оформления приходит из SettingModalNew (white/black).
const mode = inject("colormode", ref("white"));

// Уровень сигнала микрофона (0..100) заполняет линию, остаток остаётся серым.
// Значение приходит из VAD-ворклета, клампим на случай выброса.
const levelWidth = computed(() => {
  const raw = props.currentMicroLevel;
  const level = Number.isFinite(raw) ? Math.min(Math.max(raw, 0), 100) : 0;
  return { filled: level, empty: 100 - level };
});
</script>
<template>
  <div
    class="noise-suppression-block"
    :class="{ [mode]: true }"
    draggable="false"
    @dragstart.prevent
  >
    <div class="level-title">{{ locale.microLevel }}</div>
    <div
      class="level-line"
      draggable="false"
      @dragstart.prevent
      @click.stop
    >
      <div
        class="part-line filled"
        :style="{ width: `${levelWidth.filled}%` }"
      />
      <div
        class="part-line empty"
        :style="{ width: `${levelWidth.empty}%` }"
      />
    </div>
    <SwitchItem
      :model-value="noiseSuppression"
      :text="locale.noiseSuppression"
      draggable="false"
      @update:model-value="(value) => emit('updateNoiseSuppression', value)"
      @dragstart.prevent
      @click.stop
    />
  </div>
</template>
<style lang="scss" scoped>
.noise-suppression-block {
  display: flex;
  flex-direction: column;
  margin-bottom: 6px;
}

.level-title {
  margin-bottom: 8px;
  font-family: Open Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16.34px;
  color: #747474;
}

.black .level-title {
  color: #a4a4a4;
}

.level-line {
  display: flex;
  width: 100%;
  height: 4px;
  margin-bottom: 8px;
  border-radius: 2px;
  overflow: hidden;

  & .part-line {
    flex: none;
    height: 100%;
  }

  & .filled {
    background-color: #4e8c4d;
  }

  & .empty {
    background-color: #d8d8d8;
  }
}
</style>
